
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import "./SpecialFacility.css";
import Aos from 'aos';
import './aos.css';
import React, { useState, useEffect } from 'react';

function Swimming() {
  useEffect(() => {
    Aos.init({});
  }, [])
  return (
    // <div className="facility-container">
    //   <div className="facility-box">
    //     <h2 className="facility-title">Swimming</h2>
    //     <p className="facility-text">
    //        <div>Swimming is a compulsory part of the PE curriculum. The Academy has an indoor heated swimming pool on the premises. All the students from Grades 1 to 12 are expected to take lessons, at least once a week in their swimming costumes (girls) and swimming trunks (boys), along with caps, goggles and towels.</div>
    //     </p>
    //   </div>
    // </div>
    <Container className="my-5">
      <Row>
        <Col xs={6} md={5}>
          <div data-aos="flip-left" data-aos-duration="2500">
            <Image
              src="imagesspecialfacilities/Swimming.jpg"
              rounded
              style={{ width: '100%', objectFit: 'cover', marginTop: '30px', boxShadow: ' rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px, rgba(0, 0, 0, 0.35) 0px 5px 15px' }}
            />
          </div>
        </Col>
        <Col xs={6} md={7}>
          <div className="facility-text">
            <h2 className="facility-title">Swimming</h2>
            <br />
            <p>
              Swimming is a compulsory part of the PE curriculum. The Academy has an indoor heated swimming pool on the premises. All the students from Grades 1 to 12 are expected to take lessons, at least once a week in their swimming costumes (girls) and swimming trunks (boys), along with caps, goggles and towels.            </p>
          </div>
        </Col>
      </Row>

    </Container>
  );
}

export default Swimming;
